import { render, staticRenderFns } from "./purchaseReturnList.vue?vue&type=template&id=13560a38&scoped=true&"
import script from "./purchaseReturnList.vue?vue&type=script&lang=js&"
export * from "./purchaseReturnList.vue?vue&type=script&lang=js&"
import style0 from "./purchaseReturnList.vue?vue&type=style&index=0&id=13560a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13560a38",
  null
  
)

export default component.exports